export const mapFilterDisplayNames = (label: string) => {
    if (label === "mailboxOwners") return "Mailbox ID";
    return label?.replace(/(?<!^)([A-Z])/g, ' $1');
}
